import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Collections: BleskIcon = forwardRef(function Collections(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <rect
        x="2.99609"
        y="2.99609"
        width="7.00292"
        height="7.00292"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="14.0005"
        y="2.99609"
        width="7.00292"
        height="7.00292"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.99609"
        y="14"
        width="7.00292"
        height="7.00292"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="14.0005"
        y="14"
        width="7.00292"
        height="7.00292"
        rx="1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
